import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLoadingState } from "redux/actions";
import { useHistory } from "react-router-dom";

import { Card, Row, Col } from "react-bootstrap";
import { ConfirmAlert } from "components";

import { remove } from "helpers/";

import { RootState, AppDispatch } from "redux/store";

import { createParsedDate, markPostAsViwed, getFiles } from "utils";

import { IFeedbackLisagem, IArquivo } from "types";
import ImageComponent from "./Image";

interface IPost {
  post: IFeedbackLisagem;
  resetList: () => Promise<void>;
  setFeedbackUpdatingId: React.Dispatch<React.SetStateAction<number | null>>;
}

const formatDateObj: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

const FeedbackPost: React.FC<IPost> = ({
  post,
  resetList,
  setFeedbackUpdatingId,
}) => {
  const [arquivos, setArquivos] = useState<IArquivo[]>([]);

  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: RootState) => ({
    user: state.Auth.user,
  }));
  const { push } = useHistory();

  const canEditThisPost = post.origem_usuario_id === user.usuario.id;

  const canExcludeThistPost = post.origem_usuario_id === user.usuario.id;

  const handleClick = async () => {
    await markPostAsViwed(post, user.usuario.colaborador?.id);
    push(`/feedback/${post.id}`);
  };

  const handleEdit = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    setFeedbackUpdatingId(post.id);
  };

  useEffect(() => {
    getFiles(post.arquivos, setArquivos);
  }, [post]);

  const deletePost = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    dispatch(setLoadingState(true));
    try {
      await remove(`/feedback/${post.id}`);
      await resetList();
    } catch (error) {
      console.log({ error });
    }
    dispatch(setLoadingState(false));
  };

  return (
    <div
      className="border border-light p-2 mb-3 pb-1 cursor-pointer"
      onClick={handleClick}
    >
      <div className="d-flex justify-content-between border-bottom pb-3">
        <div className="d-flex align-items-start">
          <ImageComponent
            className="me-2 avatar-sm rounded-circle"
            avatarObj={post.origem_usuario.avatar}
          />
          <div className="w-100">
            <p className="text-muted mb-0">Por:</p>
            <h5 className="m-0">{post.origem_usuario.nome}</h5>
          </div>
        </div>
        <div>
          {canEditThisPost ? (
            <i
              className="action-icon hover mdi mdi-pencil-outline mx-2"
              style={{ fontSize: "1.2rem" }}
              onClick={handleEdit}
            />
          ) : null}
          {canExcludeThistPost ? (
            <ConfirmAlert
              text={`Você está excluindo este feedback`}
              message_success="Feedback excluído com sucesso"
              cb={deletePost}
            >
              <i
                className="mdi mdi-delete-outline"
                style={{ fontSize: "1.2rem" }}
              ></i>{" "}
            </ConfirmAlert>
          ) : null}
        </div>
      </div>
      {arquivos.length ? (
        <div className="mt-1 overflow-auto d-flex">
          {React.Children.toArray(
            arquivos.map((arquivo) => {
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border"
                  style={{ marginRight: "10px", minWidth: "150px" }}
                >
                  <div className="p-2">
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-primary rounded">
                            {arquivo.nome.slice(0, 2)}
                          </span>
                        </div>
                      </Col>
                      <Col
                        className="ps-0 overflow-hidden"
                        style={{ textOverflow: "ellipsis" }}
                      >
                        <a
                          href={arquivo.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-muted fw-bold text-nowrap"
                        >
                          {arquivo.nome}
                        </a>
                      </Col>
                    </Row>
                  </div>
                </Card>
              );
            })
          )}
        </div>
      ) : null}
      <div className="d-flex justify-content-between mt-1">
        <div>
          {post.visualizado ? (
            <div className="text-success">
              Visualizado <i className="mdi mdi-check-all" />
            </div>
          ) : (
            <>
              Não visualizado <i className="mdi mdi-check" />
            </>
          )}
        </div>
        <div className="d-flex">
          {post.data_feedback_aovivo ? (
            <>
              <p className="text-muted m-0">
                <small>
                  Aplicado em:{" "}
                  {createParsedDate(post.data_feedback_aovivo, formatDateObj)}
                </small>
              </p>
              <p className="m-0 mx-1">/</p>
            </>
          ) : null}
          <p className="text-muted m-0">
            <small>
              Registrado em: {createParsedDate(post.createdAt, formatDateObj)}
            </small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPost;
